var _title, _circle, _path, _path2, _rect, _path3, _path4, _path5, _rect2, _rect3, _path6, _path7, _path8, _rect4, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUnplugged = function SvgUnplugged(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 140 140",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Un-Plugged")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 60,
    fill: "#edf0f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2,72.1A7.4,7.4,0,0,1,16,70.8l-10.5-7A1.5,1.5,0,0,1,5,61.6a1.6,1.6,0,0,1,2.3-.5l10.5,7.1a4.4,4.4,0,0,0,6.1-1.3l1.7-2.4a5.5,5.5,0,0,1,7.6-1.6l7.9,5.3a1.7,1.7,0,0,1,.4,2.3,1.6,1.6,0,0,1-2.2.4l-7.9-5.3a2.2,2.2,0,0,0-3.1.7l-1.7,2.4A7.7,7.7,0,0,1,20.2,72.1Z",
    fill: "#53717f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.6,70.2l-.9-.3-10.5-7.1a4.2,4.2,0,0,0-3.3-.6,4,4,0,0,0-2.8,1.9l-1.7,2.4a5.1,5.1,0,0,1-3.5,2.4,5.1,5.1,0,0,1-4.1-.9l-7.9-5.2a1.7,1.7,0,0,1-.4-2.3,1.6,1.6,0,0,1,2.2-.4l7.9,5.3a2.5,2.5,0,0,0,1.7.3,2.1,2.1,0,0,0,1.4-1l1.7-2.4a7.7,7.7,0,0,1,4.9-3.3,7.3,7.3,0,0,1,5.7,1.2l10.5,7a1.5,1.5,0,0,1,.5,2.2A1.6,1.6,0,0,1,133.6,70.2Z",
    fill: "#53717f"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94.6,
    y: 59.6,
    width: 7.9,
    height: 2.31,
    rx: 0.5,
    transform: "translate(203.9 12.7) rotate(123.8)",
    fill: "#244759"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7,58.8a2.1,2.1,0,0,1-.4.6L97.6,62a11.1,11.1,0,0,1-15.4,3l-9.8-6.5L75,54.7l9.7,6.5A11.1,11.1,0,0,0,99.7,58.8Z",
    fill: "#244759"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7,58.8a11.1,11.1,0,0,1-15,2.4L75,54.7,86.5,37.4,96.3,44A11.1,11.1,0,0,1,99.7,58.8Z",
    fill: "#6d8491"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5,54.7l3.6,2.4a.9.9,0,0,0,1.3-.3l-3.6,5.5a1,1,0,0,1-1.4.3l-3.6-2.4a1.1,1.1,0,0,1-.2-1.4l3.6-5.5A1.1,1.1,0,0,0,73.5,54.7Z",
    fill: "#3c5b6c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.9,
    y: 42.6,
    width: 24.4,
    height: 6.27,
    rx: 1,
    transform: "translate(-1.6 88.5) rotate(-56.2)",
    fill: "#3c5b6c"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 69.1,
    width: 7.9,
    height: 2.31,
    rx: 0.5,
    transform: "translate(123 74.9) rotate(123.8)",
    fill: "#244759"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9,68.5l-.5.6-1.7,2.5a11.2,11.2,0,0,0,3.1,15.5l9.7,6.5,2.6-3.8-9.8-6.5A11.1,11.1,0,0,1,42.9,68.5Z",
    fill: "#244759"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9,68.5a11.1,11.1,0,0,0,3.4,14.8l9.8,6.5L67.6,72.6,57.9,66A11.1,11.1,0,0,0,42.9,68.5Z",
    fill: "#6d8491"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6,91.2l-3.5-2.4a1,1,0,0,1-.3-1.4l-3.7,5.5a1,1,0,0,0,.3,1.4l3.5,2.4a1.1,1.1,0,0,0,1.4-.3L58,90.9A1.1,1.1,0,0,1,56.6,91.2Z",
    fill: "#3c5b6c"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49.4,
    y: 76.7,
    width: 24.4,
    height: 6.27,
    rx: 1,
    transform: "translate(-39 86.6) rotate(-56.2)",
    fill: "#3c5b6c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6,79.6l10.5,7a2,2,0,0,0,2.7-.6h0L66.7,77.9Z",
    fill: "#b3bfc6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2,83.3l-10.4-7-1.1,1.6L78.8,86A2,2,0,0,0,78.2,83.3Z",
    fill: "#cfd5d8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1,92.2l10.5,7a1.9,1.9,0,0,0,2.7-.5h0L58.2,90.6Z",
    fill: "#b3bfc6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7,96,59.3,89l-1.1,1.6,12.1,8.1A2,2,0,0,0,69.7,96Z",
    fill: "#cfd5d8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90,102.6h-.3l-1.2-.9a.5.5,0,0,1-.2-.8.6.6,0,0,1,.8-.2l1.2.9a.5.5,0,0,1,.2.8A.5.5,0,0,1,90,102.6Zm-3.7-2.5H86l-1.2-.8a.6.6,0,0,1-.2-.8.7.7,0,0,1,.9-.2l1.2.8a.5.5,0,0,1,.1.8A.5.5,0,0,1,86.3,100.1Zm-3.6-2.4h-.4l-1.2-.9a.5.5,0,0,1-.1-.8c.1-.3.5-.3.8-.2l1.2.9a.5.5,0,0,1,.2.8A.5.5,0,0,1,82.7,97.7Z",
    fill: "#fbd149"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1,92.6H94l-1.5-.3c-.3,0-.5-.3-.5-.7a.8.8,0,0,1,.7-.5l1.4.3a.5.5,0,0,1,.5.7A.5.5,0,0,1,94.1,92.6Zm-4.4-.7h-.1l-1.5-.2a.8.8,0,0,1-.5-.7c.1-.4.4-.6.7-.5l1.5.2c.3,0,.5.4.5.7A.6.6,0,0,1,89.7,91.9Zm-4.4-.7h-.1L83.8,91c-.3-.1-.6-.4-.5-.7a.5.5,0,0,1,.7-.5l1.4.2c.4.1.6.4.5.7A.6.6,0,0,1,85.3,91.2Z",
    fill: "#fbd149"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3,110.1a.5.5,0,0,1-.5-.3l-.8-1.2a.8.8,0,0,1,.2-.9,1,1,0,0,1,.9.2l.7,1.3a.5.5,0,0,1-.2.8ZM80,106.3a.5.5,0,0,1-.5-.3l-.8-1.2a.7.7,0,0,1,.2-.8.7.7,0,0,1,.9.2l.7,1.2a.5.5,0,0,1-.2.8Zm-2.3-3.7a.5.5,0,0,1-.5-.3l-.7-1.3a.5.5,0,0,1,.2-.8.6.6,0,0,1,.8.2l.7,1.3a.6.6,0,0,1-.2.8Z",
    fill: "#fbd149"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnplugged, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unplugged.7ed4b59b.svg";
export { ForwardRef as ReactComponent };